var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPaypal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Paypal-Logo--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Paypal Logo Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.71 6.44a0.75 0.75 0 0 0 -1.31 0.74 4 4 0 0 1 0.28 2.87 6 6 0 0 1 -6 4.82h-3.6a0.75 0.75 0 0 0 -0.72 0.57L9 20.88H4.7a0.75 0.75 0 1 0 0 1.5h4.88a0.74 0.74 0 0 0 0.72 -0.57l1.38 -5.44h3a7.49 7.49 0 0 0 7.43 -6 5.54 5.54 0 0 0 -0.4 -3.93Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55 19.23 9 13.62h3a7.25 7.25 0 0 0 7.35 -5.81 4.92 4.92 0 0 0 -0.82 -4.35 5.24 5.24 0 0 0 -4.1 -1.84H6.16a0.5 0.5 0 0 0 -0.49 0.38l-4 17a0.49 0.49 0 0 0 0.09 0.42 0.51 0.51 0 0 0 0.39 0.19h4.91a0.5 0.5 0 0 0 0.49 -0.38Zm1.21 -9.41 1 -4.47a0.51 0.51 0 0 1 0.53 -0.35h2.39a2.26 2.26 0 0 1 1.32 0.38 2.18 2.18 0 0 1 0.77 2.45 3.34 3.34 0 0 1 -1 1.66 3.2 3.2 0 0 1 -0.55 0.42 3.29 3.29 0 0 1 -1.73 0.52H9.24a0.5 0.5 0 0 1 -0.48 -0.62Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPaypal);
export default ForwardRef;